import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface EmptyStateProps {
  /** One plain sentence. No illustration, no icon. */
  message: string;
  /** Optional single action beneath the sentence. */
  action?: ReactNode;
  /** Compact padding for table bodies and inspector sections. */
  compact?: boolean;
  className?: string;
}

/** Empty state (DESIGN_SYSTEM section 10.2): centred text-sm --mute, one sentence. */
export function EmptyState({ message, action, compact = false, className }: EmptyStateProps) {
  return (
    <div
      role="status"
      className={cn('flex flex-col items-center justify-center gap-3 text-center', compact ? 'px-4 py-6' : 'px-8 py-16', className)}
    >
      <p className="text-sm text-mute">{message}</p>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
